import React, { Component } from 'react';
import './Card.css';
import './Common.css';

function numToCard(num) {
    let rank = Math.floor(num / 4);
    let suit = num % 4;
    let ret = '';
    if (rank < 8) {
        ret += rank + 2;
    } else {
        switch (rank) {
            case 8:
                ret += '0';
                break;
            case 9:
                ret += 'J';
                break;
            case 10:
                ret += 'Q';
                break;
            case 11:
                ret += 'K';
                break;
            case 12:
                ret += 'A';
                break;
            default:
                break;
        }
    }
    switch (suit) {
        case 0:
            ret += 'H';
            break;
        case 1:
            ret += 'S';
            break;
        case 2:
            ret += 'D';
            break;
        case 3:
            ret += 'C';
            break;
        default:
            break;
    }
    return ret;
}

function GetCardUrl(card) {
    let cardurl;
    if (card || card === 0) {
        cardurl = 'cards/' + numToCard(card) + '.png';
    } else {
        cardurl = 'cards/back.jpg';
    }

    return cardurl;
}

class Card extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: '',
            hasCard: true,
            used: true,
            show: true
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if ((!nextProps.card && nextProps.card !== 0) || nextProps.card < 0) {
            prevState.hasCard = false;
        } else {
            prevState.url = GetCardUrl(nextProps.card);
            prevState.hasCard = true;
        }

        prevState.used = true;
        if (nextProps.used === false) {
            prevState.used = false;
        }

        prevState.show = true;
        if (nextProps.show === false) {
            prevState.show = false;
        }

        return prevState;
    }

    render() {
        return this.state.hasCard ? (
            <div className={'disable-touch ' + (this.state.used ? '' : ' not-used')}>
                <div className={'flip-card' + (this.state.show ? '' : ' card-hidden')}>
                    <div
                        className={
                            'flip-card-inner ' + (this.props.fast ? 'flip-card-inner-fast' : 'flip-card-inner-slow')
                        }
                    >
                        <div className="flip-card-front">
                            <img className="img-fluid" src={this.state.url} alt="card" />
                        </div>
                        <div className="flip-card-back">
                            <img className="img-fluid" src={'cards/back.jpg'} alt="card_back" />
                        </div>
                    </div>
                </div>
                <div className={'flip-card-back' + (this.state.show ? ' card-hidden' : '')}>
                    <img className="img-fluid" src={'cards/back.jpg'} alt="card_back" />
                </div>
            </div>
        ) : null;
    }
}

export default Card;
export { GetCardUrl };
